import { useContext, useState } from "react";
import { AdminContext } from "../../contexts/contexAdmin";
import { StatusUser, UserAdmin } from "../../styles/admin";
import { RiUserAddFill } from "react-icons/ri";
import { FaUserEdit } from "react-icons/fa";
import { ImBin } from "react-icons/im";
import { AiOutlineLineChart } from "react-icons/ai";
import { ModalGraphicGateway } from "./modalAdmin";
import { HomeContext } from "../../contexts/contexHome";
import { format } from "date-fns";

export const AdminUser = () => {
  const {
    usersSave,
    modalCreatingUser,
    setModalCreatingUser,
    setSaveUserId,
    modalUserDeletConfirmation,
    setModalUserDeletConfirmation,
    modaUpdatePassword,
    setModalUpdatePassword,
    modalEditUser,
    setModalEditUser,
    setIdGateway,
    setUnidadesuser,
  } = useContext(AdminContext);

  const { setModalGtwHistorico } = useContext(HomeContext);

  return (
    <UserAdmin>
      <div className="Header">
        <h2>Usuários</h2>
        <div className="addIcon">
          <RiUserAddFill
            onClick={() => {
              setModalCreatingUser(!modalCreatingUser);
            }}
          />
          <span>Criar Novo Usuários</span>
        </div>
      </div>
      <ul>
        {usersSave.map((user) => {
          return (
            <li key={user.id}>
              {user.gateway !== null && (
                <AiOutlineLineChart
                  className="iconGt"
                  onClick={() => {
                    setIdGateway(user.gateway);
                    setModalGtwHistorico(true);
                  }}
                />
              )}
              <ImBin
                className="iconBin"
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalUserDeletConfirmation(!modalUserDeletConfirmation);
                }}
              />
              <FaUserEdit
                className="iconEdit"
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalEditUser(!modalEditUser);
                }}
              />
              <StatusUser
                color={
                  user.online
                    ? "rgba(41, 162, 11, 1)"
                    : "rgba(131, 131, 131, 0.6)"
                }
              >
                <span className="online"></span>
                <span>{user.online ? "Online" : "Offline"}</span>
              </StatusUser>
              <span className="emailAdmin">E-mail : {user.email}</span>
              <span>Usuário : {user.username}</span>
              <span>Controlador : {user.permission ? "Sim" : "Não"}</span>
              <span>Admin : {user.is_superuser ? "Sim" : "Não"}</span>
              <button
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalUpdatePassword(!modaUpdatePassword);
                }}
              >
                Alterar Senha
              </button>
              <button
                disabled={user.gateway !== null}
                onClick={() => {
                  setSaveUserId(user.id);
                  setModalEditUser(!modalEditUser);
                }}
              >
                Editar Usuário
              </button>
              <button
                onClick={() => {
                  setSaveUserId(user.id);
                  setUnidadesuser(true);
                }}
              >
                Unidades
              </button>
              <div className="userAtulizacao">
                <span>
                  {format(new Date(user.updatedAt), "HH:mm - dd/MM/yyyy")}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </UserAdmin>
  );
};
